import * as React from 'react';
import { Button } from '../../designSystem/button/Button';
import { ButtonRow } from '../../designSystem/button/ButtonRow';
import { TextField } from '../../designSystem/formField/text/TextField';
import { H1 } from '../../designSystem/typography/Heading';
import { useHistory } from 'react-router-dom';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { login } from '../../api/adminClientApi';
import { AmorgAdminPageProvider } from './AmorgAdminPageContext';
import { Label } from '../../designSystem/Label';
import { rawColors } from '../../designSystem/colors/color';
import { CardLogin, CardLoginWrapper, LoginLayout, LoginText, SpecialHeaderWrapper } from '../../designSystem/layouts/LayoutLogin';

export function AmorgAdminLogin():JSX.Element
{

    function getRandomImageAndText() {
        const index = Math.floor(Math.random() * imageSet.length);
        return imageSet[index];
    }
    
    const imageSet = [
        {rightImageUrl: '/images/oracle_01.jpg', text: 'Are you the one?!'},
        {rightImageUrl: '/images/gandalf_01.jpg', text: 'Only you have the power...'},
        {rightImageUrl: '/images/spider_01.jpg', text: 'With great power comes great responsibility.'},
        {rightImageUrl: '/images/ash_01.jpg', text: 'I choose you.'}
    ];

    const selected = getRandomImageAndText();

    return (
        <AmorgAdminPageProvider>
            <LoginLayout 
                leftBackgroundColor="#eeeeee" 
                rightImageUrl={selected.rightImageUrl}
                leftSide={
                    <Login />
                }
                rightSide={
                    <LoginText>{selected.text}</LoginText>
                } />
        </AmorgAdminPageProvider>
    );
}


function Login():JSX.Element
{
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const history = useHistory();

    async function handleLogin(e?: React.FormEvent) {
        if (e) e.preventDefault();
        const result = await login(email, password);
        if(result === true)
            history.push('/amorgy');
    }

    return (
        <CardLoginWrapper>
            <Flex flexDirection="column">
                <SpecialHeaderWrapper><H1>Log ind</H1></SpecialHeaderWrapper>
                <CardLogin>
                    <form onSubmit={handleLogin}>
                        <Flex flexDirection='column' gap={16}>
                            <Flex flexDirection='column'>
                                <Label color={rawColors.white}>E-mail</Label>
                                <TextField 
                                    value={email} 
                                    onChange={setEmail}
                                    type="email"
                                    validator={() => ({ valid: true })} />
                            </Flex>
                            <Flex flexDirection='column'>
                                <Label color={rawColors.white}>Adgangskode</Label>
                                <TextField 
                                    value={password} 
                                    onChange={setPassword}
                                    type="password"
                                    validator={() => ({ valid: true })} />
                            </Flex>
                            <ButtonRow>
                                <Button variant="filled" text='Log ind'
                                    onClick={handleLogin} />
                            </ButtonRow>
                        </Flex>
                    </form>
                </CardLogin>
            </Flex>
        </CardLoginWrapper>
    );
}